var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26037 15.5819H3.45372C1.54962 15.5819 0 14.0322 0 12.1266V3.45606C0 1.5504 1.54962 0 3.45372 0H7.2518C9.15746 0 10.7079 1.5504 10.7079 3.45606V4.18217C10.7079 4.50472 10.4461 4.76649 10.1235 4.76649C9.80099 4.76649 9.53922 4.50472 9.53922 4.18217V3.45606C9.53922 2.19393 8.51315 1.16864 7.2518 1.16864H3.45372C2.19393 1.16864 1.16864 2.19393 1.16864 3.45606V12.1266C1.16864 13.3879 2.19393 14.4132 3.45372 14.4132H7.26037C8.51627 14.4132 9.53922 13.3911 9.53922 12.1352V11.4005C9.53922 11.0779 9.80099 10.8161 10.1235 10.8161C10.4461 10.8161 10.7079 11.0779 10.7079 11.4005V12.1352C10.7079 14.0361 9.16058 15.5819 7.26037 15.5819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 11,
    height: 2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45038 7.2066H16V8.37524H5.45038V7.2066Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4158 8.37524H6.0347C5.71215 8.37524 5.45038 8.11347 5.45038 7.79092C5.45038 7.46838 5.71215 7.2066 6.0347 7.2066H15.4158C15.7383 7.2066 16.0001 7.46838 16.0001 7.79092C16.0001 8.11347 15.7383 8.37524 15.4158 8.37524Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 4,
    width: 4,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5507 4.93576H16V10.6471H12.5507V4.93576Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1348 10.6471C12.9852 10.6471 12.8349 10.5902 12.7211 10.4749C12.4936 10.2459 12.4944 9.87658 12.7227 9.64908L14.5878 7.79094L12.7227 5.93358C12.4944 5.70609 12.4928 5.3368 12.7211 5.10775C12.9486 4.87869 13.3179 4.87869 13.547 5.10619L15.8281 7.37724C15.9388 7.48632 16.0003 7.6359 16.0003 7.79094C16.0003 7.94598 15.9388 8.09557 15.8281 8.20464L13.547 10.4765C13.4332 10.5902 13.2836 10.6471 13.1348 10.6471Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.5819,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/log-out-icon.ad5d5660.svg";
export { ForwardRef as ReactComponent };